import { render, staticRenderFns } from "./simulation.vue?vue&type=template&id=528d3eb2&scoped=true"
import script from "./simulation.vue?vue&type=script&lang=js"
export * from "./simulation.vue?vue&type=script&lang=js"
import style0 from "./simulation.vue?vue&type=style&index=0&id=528d3eb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528d3eb2",
  null
  
)

export default component.exports